// Copyright (c) Docugami, Inc. All rights reserved.
export class LcsSettings {
    public detailThreshold = 3;
    public fastFindSearchLength = 12; // used in DoLcsAlgorithm
    public fastFindSearchMatch = 6; // used in DoLcsAlgorithm

    // The LCS algorithm is peculiar when debugging.  Often the only way to debug what is going on are pretty massive text dumps of data structures.
    // But sometimes I want to turn on only some of these dumps, but not other data structure dumps.  And then when finished with debugging, I want
    // to turn all data structure dumps off. But if the code were written if (true) or if (false), then it is difficult to find and turn off all data
    // structure dumps when finished debugging.  So a long time ago, I put these into variables, so that I can position on the s_True variable, press
    // F12, and find all places where I had turned on data structure dumps.  I don't want to conflate turning on data structure dumps with other
    // debugging functionality.  I very often want to, for example, turn on data structure dumps for the code to find common sequences at the beginning,
    // and then only in certain circumstances, and I don't want to see any other data structure dumps.  This is the purpose of lcsDebugTrue and lcsDebugFalse.

    public static lcsDebugTrue = true;
    public static lcsDebugFalse = false;
}
